export const OVERVIEW_CLIP_LIMIT = 350

const OVERVIEW_SUFFIX = ' ...'

export function hasExpandableOverview(text, maxLength = OVERVIEW_CLIP_LIMIT) {
  return String(text || '').trim().length > maxLength
}

export function clipOverview(text, maxLength = OVERVIEW_CLIP_LIMIT) {
  return clipOverviewWithSuffix(text, maxLength)
}

export function clipOverviewWithSuffix(
  text,
  maxLength = OVERVIEW_CLIP_LIMIT,
  suffix = OVERVIEW_SUFFIX,
) {
  const value = String(text || '').trim()
  if (value.length <= maxLength) return value

  const maxBaseLength = Math.max(0, maxLength - suffix.length)
  let clipped = value.slice(0, maxBaseLength).trimEnd()
  const lastSpaceIndex = clipped.lastIndexOf(' ')
  if (lastSpaceIndex > 0) {
    clipped = clipped.slice(0, lastSpaceIndex)
  }

  return `${clipped}${suffix}`
}
